import { BaseHandler } from './baseHandler';
// TODO(MC-5023): Move the common logic to a common fn without breaking the ts types.
/**
 * ===================================
 *        Middleware Handler
 * ===================================
 * Wraps the given handler with middleware functionality.
 */
class MiddlewareHandler extends BaseHandler {
  constructor(handlerInstance, middlewares, context, middlewareConfig) {
    super();
    this.handlerInstance = handlerInstance;
    this.middlewares = middlewares;
    this.context = context;
    this.middlewareConfig = middlewareConfig;
    this.context = context;
    this.handlerInstance = handlerInstance;
    this.middlewares = middlewares;
    this.middlewareConfig = middlewareConfig;
  }
  requestTransformer(operation, sequenceConfigValue, customResponse) {
    var _this = this;
    const originalRequestTransformer = this.handlerInstance.requestTransformer.bind(this.handlerInstance);
    const withMiddleware = this.middlewares.reduceRight((result, nextMiddleware) => function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return nextMiddleware.onRequestTransformer(args, result, _this.context, _this.middlewareConfig[nextMiddleware.getKey()] || {});
    }, originalRequestTransformer);
    return withMiddleware(operation, sequenceConfigValue, customResponse);
  }
  fetchPrimary(operation, forward) {
    var _this2 = this;
    const originalFetchPrimary = this.handlerInstance.fetchPrimary.bind(this.handlerInstance);
    const withMiddleware = this.middlewares.reduceRight((result, nextMiddleware) => function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return nextMiddleware.onFetchPrimary(args, result, _this2.context, _this2.middlewareConfig[nextMiddleware.getKey()] || {});
    }, originalFetchPrimary);
    return withMiddleware(operation, forward);
  }
  fetchCustom(operation, transformedOperation, sequenceConfigValue, primaryResponse) {
    var _this3 = this;
    const originalFetchCustom = this.handlerInstance.fetchCustom.bind(this.handlerInstance);
    const withMiddleware = this.middlewares.reduceRight((result, nextMiddleware) => function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return nextMiddleware.onFetchCustom(args, result, _this3.context, _this3.middlewareConfig[nextMiddleware.getKey()] || {});
    }, originalFetchCustom);
    return withMiddleware(operation, transformedOperation, sequenceConfigValue, primaryResponse);
  }
  responseTransformer(operation, transformedOperation, sequenceConfigValue, primaryResponse, customResponse) {
    var _this4 = this;
    const originalResponseTransform = this.handlerInstance.responseTransformer.bind(this.handlerInstance);
    const withMiddleware = this.middlewares.reduceRight((result, nextMiddleware) => function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return nextMiddleware.onResponseTransformer(args, result, _this4.context, _this4.middlewareConfig[nextMiddleware.getKey()] || {});
    }, originalResponseTransform);
    return withMiddleware(operation, transformedOperation, sequenceConfigValue, primaryResponse, customResponse);
  }
}
export { MiddlewareHandler };